module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-bb-bg-1-bebce10bfb6f98074e8c9ed4ecf4c6e3.png";